import { useRef, ChangeEvent, useCallback } from "react"
import { css } from "@emotion/react"
import { Button, Layout, Modal, Typography } from "matsuri-ui"
import { useTranslation } from "@/hooks/useTranslation"

interface PhotoCaptureModalProps {
    isOpen: boolean
    onClose: () => void
    onPhotoCapture: (file: File) => void
}

export const PhotoCaptureModal = ({
    isOpen,
    onClose,
    onPhotoCapture
}: PhotoCaptureModalProps) => {
    const { t } = useTranslation()
    const inputRef = useRef<HTMLInputElement>(null)

    const handleFileChange = useCallback(
        (event: ChangeEvent<HTMLInputElement>) => {
            const files = event.currentTarget.files
            if (!files?.[0]) return
            onPhotoCapture(files[0])
        },
        [onPhotoCapture]
    )

    const handleCaptureClick = () => {
        inputRef.current?.click()
    }

    return (
        <Modal
            open={isOpen}
            onClickOutside={onClose}
            backdrop
            body={
                <div
                    css={css`
                        display: flex;
                        flex-direction: column;
                        gap: 24px;
                        max-width: 75vw;
                        max-height: 75vh;
                        padding: 8px;
                        overflow-y: auto;
                    `}
                >
                    <Typography variant="h4" bolder align="center">
                        {t("番号変更後のキーボックスを撮影してください")}
                    </Typography>
                    <img
                        src="/assets/keybox_rotation_instruction.png"
                        alt={t("キーボックス撮影の参考例")}
                        css={css`
                            max-width: 100%;
                            height: auto;
                        `}
                    />
                    <Typography align="left">
                        {t(
                            "変更後の番号がわかるように、番号が全て写るように撮影してください。"
                        )}
                    </Typography>
                </div>
            }
            footer={
                <Layout.Row>
                    <Button
                        variant="filled"
                        color="primary"
                        onClick={handleCaptureClick}
                        fullWidth
                    >
                        {t("撮影またはアップロード")}
                    </Button>
                    <input
                        ref={inputRef}
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                    />
                </Layout.Row>
            }
        />
    )
}
